import { Checkbox } from '@wartek-id/checkbox-v1'

import { Card, CardBody } from 'app/KinerjaShared/components/Card'

type Props = {
  isConfirmed: boolean
  onConfirmChange: (checked: boolean) => void

  confirmationText?: string
}

export function ConfirmationSection({
  isConfirmed,
  onConfirmChange,
  confirmationText = 'Saya melaksanakan Kinerja Harian sesuai dengan data di atas',
}: Props) {
  return (
    <Card withBorder>
      <CardBody className="p-6 bg-info-50">
        <div className="bg-surface-informational-subdued p-4 flex">
          <Checkbox
            checked={isConfirmed}
            onChange={(e) => {
              onConfirmChange(e.target.checked)
            }}
            className="!items-center"
          >
            {confirmationText}
          </Checkbox>
        </div>
      </CardBody>
    </Card>
  )
}
